// extracted by mini-css-extract-plugin
export default {"icon":"PageModal_icon__PGLf4","close":"PageModal_close__ooTiU"};